import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from 'projects/firebase/src/lib/services/auth.service';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {GoogleTagService} from 'projects/shared/src/lib/services/google-tag.service';
import {BusyService} from 'projects//paid_ukr/src/app/services/busy.service';
import {environment} from '../../../../environments/environment';
import {delay, of, Subscription} from 'rxjs';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
    error: string | null;
    @Output() action: EventEmitter<any> = new EventEmitter<any>();
    emailSent = false;
    email = '';
    $userSubscription: Subscription;

    constructor(
        public authService: AuthService,
        public dataService: DataService,
        private gtService: GoogleTagService,
        private busy: BusyService
    ) {
    }

    ngOnInit(): void {

    }

    SignInWithEmailLink(email) {
        this.authService.sendEmailLink(email)
            .then(() => {
                this.emailSent = true;
            }, () => {
            })
            .catch(() => {
            });
    }

    loginWithGoogle() {
        this.busy.setState(true);
        this.authService.GoogleAuth()
            .catch(err => {
                this.busy.setState(false);
                throw err;
            })
            .then(() => {
                return environment.production ? this.gtService.event('login_success') : of(null);
            })
            .then((res) => {
                this.$userSubscription = this.authService.$userState
                    .pipe(
                        delay(500)
                    )
                    .subscribe((data) => {
                            this.busy.setState(false);
                            if (data) {
                                this.action.emit({type: 'loggedIn', key: res});
                            }
                        }
                    );
            }, () => {
                this.busy.setState(false);
            });
    }

    goToSignIn() {
        this.action.emit({type: 'switch', key: 'signin'});
    }

    onClose() {
        this.action.emit({type: 'close'});
    }

}
